import { render } from "./FamilyConfig.vue?vue&type=template&id=855ae814"
import script from "./FamilyConfig.vue?vue&type=script&lang=js"
export * from "./FamilyConfig.vue?vue&type=script&lang=js"

import "./FamilyConfig.vue?vue&type=style&index=0&id=855ae814&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__